import { render, staticRenderFns } from "./TableInput.vue?vue&type=template&id=2cc92b74&scoped=true"
import script from "./TableInput.vue?vue&type=script&lang=js"
export * from "./TableInput.vue?vue&type=script&lang=js"
import style0 from "./TableInput.vue?vue&type=style&index=0&id=2cc92b74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc92b74",
  null
  
)

export default component.exports